import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _15b5b380 = () => interopDefault(import('@/pages/404.vue' /* webpackChunkName: "" */))
const _642a4cda = () => interopDefault(import('@/pages/index.vue' /* webpackChunkName: "" */))
const _2f479de5 = () => interopDefault(import('@/pages/articles.vue' /* webpackChunkName: "" */))
const _17c9d5b0 = () => interopDefault(import('@/pages/contact.vue' /* webpackChunkName: "" */))
const _1c209755 = () => interopDefault(import('@/pages/download_nd.vue' /* webpackChunkName: "" */))
const _4ff7cf4d = () => interopDefault(import('@/pages/download_win.vue' /* webpackChunkName: "" */))
const _b01f29e0 = () => interopDefault(import('@/pages/error.vue' /* webpackChunkName: "" */))
const _551d2790 = () => interopDefault(import('@/pages/joinUs.vue' /* webpackChunkName: "" */))
const _6643b060 = () => interopDefault(import('@/pages/search.vue' /* webpackChunkName: "" */))
const _5e3c977a = () => interopDefault(import('@/pages/tv-vip.vue' /* webpackChunkName: "" */))
const _e5a1bfee = () => interopDefault(import('@/pages/winFeedback.vue' /* webpackChunkName: "" */))
const _6521b205 = () => interopDefault(import('@/pages/winIssue.vue' /* webpackChunkName: "" */))
const _6254f1ee = () => interopDefault(import('@/pages/tv/article/id.vue' /* webpackChunkName: "" */))
const _7ef85c82 = () => interopDefault(import('@/pages/all/_params.vue' /* webpackChunkName: "" */))
const _702b01a9 = () => interopDefault(import('@/pages/article/_id.vue' /* webpackChunkName: "" */))
const _13388f1e = () => interopDefault(import('@/pages/collection/_id.vue' /* webpackChunkName: "" */))
const _3ce6f63b = () => interopDefault(import('@/pages/detail/_category/_drama/_episode.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___en"
  }, {
    path: "/ar",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___ar"
  }, {
    path: "/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___en"
  }, {
    path: "/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___en"
  }, {
    path: "/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___en"
  }, {
    path: "/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___en"
  }, {
    path: "/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___en"
  }, {
    path: "/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___en"
  }, {
    path: "/es",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___es"
  }, {
    path: "/fr",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___fr"
  }, {
    path: "/in_ID",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___in_ID"
  }, {
    path: "/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___en"
  }, {
    path: "/ms",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___ms"
  }, {
    path: "/pt",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___pt"
  }, {
    path: "/ru",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___ru"
  }, {
    path: "/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___en",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/th",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___th"
  }, {
    path: "/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___en"
  }, {
    path: "/vi",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___vi"
  }, {
    path: "/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___en"
  }, {
    path: "/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___en"
  }, {
    path: "/zh_CN",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___zh_CN"
  }, {
    path: "/zh_TW",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___zh_TW"
  }, {
    path: "/ar/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___ar"
  }, {
    path: "/ar/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___ar"
  }, {
    path: "/ar/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___ar"
  }, {
    path: "/ar/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___ar"
  }, {
    path: "/ar/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___ar"
  }, {
    path: "/ar/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___ar"
  }, {
    path: "/ar/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___ar"
  }, {
    path: "/ar/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___ar"
  }, {
    path: "/ar/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___ar",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/ar/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___ar"
  }, {
    path: "/ar/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___ar"
  }, {
    path: "/ar/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___ar"
  }, {
    path: "/es/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___es"
  }, {
    path: "/es/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___es"
  }, {
    path: "/es/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___es"
  }, {
    path: "/es/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___es"
  }, {
    path: "/es/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___es"
  }, {
    path: "/es/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___es"
  }, {
    path: "/es/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___es"
  }, {
    path: "/es/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___es"
  }, {
    path: "/es/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___es",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/es/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___es"
  }, {
    path: "/es/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___es"
  }, {
    path: "/es/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___es"
  }, {
    path: "/fr/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___fr"
  }, {
    path: "/fr/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___fr"
  }, {
    path: "/fr/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___fr"
  }, {
    path: "/fr/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___fr"
  }, {
    path: "/fr/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___fr"
  }, {
    path: "/fr/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___fr"
  }, {
    path: "/fr/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___fr"
  }, {
    path: "/fr/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___fr"
  }, {
    path: "/fr/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___fr",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/fr/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___fr"
  }, {
    path: "/fr/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___fr"
  }, {
    path: "/fr/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___fr"
  }, {
    path: "/in_ID/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___in_ID"
  }, {
    path: "/in_ID/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___in_ID"
  }, {
    path: "/in_ID/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___in_ID"
  }, {
    path: "/in_ID/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___in_ID"
  }, {
    path: "/in_ID/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___in_ID"
  }, {
    path: "/in_ID/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___in_ID"
  }, {
    path: "/in_ID/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___in_ID"
  }, {
    path: "/in_ID/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___in_ID"
  }, {
    path: "/in_ID/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___in_ID",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/in_ID/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___in_ID"
  }, {
    path: "/in_ID/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___in_ID"
  }, {
    path: "/in_ID/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___in_ID"
  }, {
    path: "/ms/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___ms"
  }, {
    path: "/ms/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___ms"
  }, {
    path: "/ms/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___ms"
  }, {
    path: "/ms/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___ms"
  }, {
    path: "/ms/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___ms"
  }, {
    path: "/ms/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___ms"
  }, {
    path: "/ms/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___ms"
  }, {
    path: "/ms/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___ms"
  }, {
    path: "/ms/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___ms",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/ms/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___ms"
  }, {
    path: "/ms/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___ms"
  }, {
    path: "/ms/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___ms"
  }, {
    path: "/pt/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___pt"
  }, {
    path: "/pt/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___pt"
  }, {
    path: "/pt/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___pt"
  }, {
    path: "/pt/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___pt"
  }, {
    path: "/pt/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___pt"
  }, {
    path: "/pt/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___pt"
  }, {
    path: "/pt/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___pt"
  }, {
    path: "/pt/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___pt"
  }, {
    path: "/pt/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___pt",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/pt/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___pt"
  }, {
    path: "/pt/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___pt"
  }, {
    path: "/pt/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___pt"
  }, {
    path: "/ru/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___ru"
  }, {
    path: "/ru/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___ru"
  }, {
    path: "/ru/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___ru"
  }, {
    path: "/ru/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___ru"
  }, {
    path: "/ru/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___ru"
  }, {
    path: "/ru/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___ru"
  }, {
    path: "/ru/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___ru"
  }, {
    path: "/ru/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___ru"
  }, {
    path: "/ru/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___ru",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/ru/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___ru"
  }, {
    path: "/ru/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___ru"
  }, {
    path: "/ru/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___ru"
  }, {
    path: "/th/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___th"
  }, {
    path: "/th/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___th"
  }, {
    path: "/th/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___th"
  }, {
    path: "/th/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___th"
  }, {
    path: "/th/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___th"
  }, {
    path: "/th/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___th"
  }, {
    path: "/th/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___th"
  }, {
    path: "/th/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___th"
  }, {
    path: "/th/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___th",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/th/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___th"
  }, {
    path: "/th/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___th"
  }, {
    path: "/th/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___th"
  }, {
    path: "/vi/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___vi"
  }, {
    path: "/vi/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___vi"
  }, {
    path: "/vi/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___vi"
  }, {
    path: "/vi/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___vi"
  }, {
    path: "/vi/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___vi"
  }, {
    path: "/vi/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___vi"
  }, {
    path: "/vi/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___vi"
  }, {
    path: "/vi/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___vi"
  }, {
    path: "/vi/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___vi",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/vi/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___vi"
  }, {
    path: "/vi/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___vi"
  }, {
    path: "/vi/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___vi"
  }, {
    path: "/zh_CN/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___zh_CN"
  }, {
    path: "/zh_CN/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___zh_CN"
  }, {
    path: "/zh_CN/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___zh_CN"
  }, {
    path: "/zh_CN/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___zh_CN"
  }, {
    path: "/zh_CN/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___zh_CN"
  }, {
    path: "/zh_CN/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___zh_CN"
  }, {
    path: "/zh_CN/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___zh_CN"
  }, {
    path: "/zh_CN/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___zh_CN"
  }, {
    path: "/zh_CN/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___zh_CN",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/zh_CN/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___zh_CN"
  }, {
    path: "/zh_CN/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___zh_CN"
  }, {
    path: "/zh_CN/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___zh_CN"
  }, {
    path: "/zh_TW/404",
    component: _15b5b380,
    meta: {"pageTitle":"404页"},
    name: "404___zh_TW"
  }, {
    path: "/zh_TW/articles",
    component: _2f479de5,
    meta: {"pageTitle":"文章资讯"},
    name: "articles___zh_TW"
  }, {
    path: "/zh_TW/contact",
    component: _17c9d5b0,
    meta: {"pageTitle":"联系我们"},
    name: "contact___zh_TW"
  }, {
    path: "/zh_TW/download",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download___zh_TW"
  }, {
    path: "/zh_TW/download_nd",
    component: _1c209755,
    meta: {"pageTitle":"下载页"},
    name: "download_nd___zh_TW"
  }, {
    path: "/zh_TW/download_win",
    component: _4ff7cf4d,
    meta: {"pageTitle":"windows下载页"},
    name: "download_win___zh_TW"
  }, {
    path: "/zh_TW/error",
    component: _b01f29e0,
    meta: {"pageTitle":"error页"},
    name: "error___zh_TW"
  }, {
    path: "/zh_TW/joinUs",
    component: _551d2790,
    meta: {"pageTitle":"加入我们"},
    name: "joinUs___zh_TW"
  }, {
    path: "/zh_TW/search",
    component: _6643b060,
    meta: {"pageTitle":"搜索结果页","noBury":true},
    name: "search___zh_TW",
    beforeEnter: function(to, from, next) {
      to.meta.fromPage = from.meta.pageTitle;
      if (from.fullPath.includes('/detail')) {
        to.meta.fromId = from.params.drama?.split('-')?.[0];
      }
      next();
    }
  }, {
    path: "/zh_TW/tv-vip",
    component: _5e3c977a,
    meta: {"pageTitle":"会员页","showTools":false,"noBury":true},
    name: "tv-vip___zh_TW"
  }, {
    path: "/zh_TW/win-feedback",
    component: _e5a1bfee,
    meta: {"pageTitle":"window客服端用户反馈页"},
    name: "win-feedback___zh_TW"
  }, {
    path: "/zh_TW/win-issue",
    component: _6521b205,
    meta: {"pageTitle":"window客服端用户问题页"},
    name: "win-issue___zh_TW"
  }, {
    path: "/ar/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___ar"
  }, {
    path: "/es/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___es"
  }, {
    path: "/fr/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___fr"
  }, {
    path: "/in_ID/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___in_ID"
  }, {
    path: "/ms/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___ms"
  }, {
    path: "/pt/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___pt"
  }, {
    path: "/ru/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___ru"
  }, {
    path: "/th/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___th"
  }, {
    path: "/vi/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___vi"
  }, {
    path: "/zh_CN/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___zh_CN"
  }, {
    path: "/zh_TW/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___zh_TW"
  }, {
    path: "/ar/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___ar"
  }, {
    path: "/ar/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___ar"
  }, {
    path: "/ar/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___ar"
  }, {
    path: "/es/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___es"
  }, {
    path: "/es/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___es"
  }, {
    path: "/es/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___es"
  }, {
    path: "/fr/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___fr"
  }, {
    path: "/fr/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___fr"
  }, {
    path: "/fr/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___fr"
  }, {
    path: "/in_ID/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___in_ID"
  }, {
    path: "/in_ID/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___in_ID"
  }, {
    path: "/in_ID/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___in_ID"
  }, {
    path: "/in/art/:id",
    component: _6254f1ee,
    meta: {"pageTitle":"tv端文章页","showTools":false},
    name: "tv-article___en"
  }, {
    path: "/ms/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___ms"
  }, {
    path: "/ms/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___ms"
  }, {
    path: "/ms/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___ms"
  }, {
    path: "/pt/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___pt"
  }, {
    path: "/pt/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___pt"
  }, {
    path: "/pt/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___pt"
  }, {
    path: "/ru/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___ru"
  }, {
    path: "/ru/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___ru"
  }, {
    path: "/ru/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___ru"
  }, {
    path: "/th/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___th"
  }, {
    path: "/th/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___th"
  }, {
    path: "/th/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___th"
  }, {
    path: "/vi/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___vi"
  }, {
    path: "/vi/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___vi"
  }, {
    path: "/vi/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___vi"
  }, {
    path: "/zh_CN/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___zh_CN"
  }, {
    path: "/zh_CN/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___zh_CN"
  }, {
    path: "/zh_CN/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___zh_CN"
  }, {
    path: "/zh_TW/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___zh_TW"
  }, {
    path: "/zh_TW/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___zh_TW"
  }, {
    path: "/zh_TW/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___zh_TW"
  }, {
    path: "/ar/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___ar"
  }, {
    path: "/es/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___es"
  }, {
    path: "/fr/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___fr"
  }, {
    path: "/in_ID/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___in_ID"
  }, {
    path: "/ms/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___ms"
  }, {
    path: "/pt/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___pt"
  }, {
    path: "/ru/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___ru"
  }, {
    path: "/th/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___th"
  }, {
    path: "/vi/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___vi"
  }, {
    path: "/zh_CN/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___zh_CN"
  }, {
    path: "/zh_TW/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___zh_TW"
  }, {
    path: "/ar/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___ar",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/es/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___es",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/fr/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___fr",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/in_ID/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___in_ID",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/ms/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___ms",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/pt/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___pt",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/ru/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___ru",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/th/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___th",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/vi/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___vi",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/zh_CN/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___zh_CN",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/zh_TW/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___zh_TW",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/all/:params",
    component: _7ef85c82,
    meta: {"pageTitle":"所有内容"},
    name: "all-params___en"
  }, {
    path: "/article/:id",
    component: _702b01a9,
    meta: {"pageTitle":"文章页"},
    name: "article-id___en"
  }, {
    path: "/collection/:id?",
    component: _13388f1e,
    meta: {"pageTitle":"片单详情页","noBury":true},
    name: "collection-id___en"
  }, {
    path: "/channel/:id/:type",
    component: _7ef85c82,
    name: "channel___en"
  }, {
    path: "/detail/:category?/:drama?/:episode?",
    component: _3ce6f63b,
    meta: {"pageTitle":"详情播放页"},
    name: "detail-category-drama-episode___en",
    beforeEnter: (to, from, next) => {
      to.meta.fromPage = from.meta.pageTitle;
      to.meta.buryParams = {
        UM_Key_DistinctID: to.params.drama?.split('-')?.[0] };

      next();
    }
  }, {
    path: "/",
    component: _642a4cda,
    meta: {"pageTitle":"首页"},
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
